// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PlusRoundSvg from '@rsuite/icon-font/lib/status/PlusRound';
var PlusRound = createSvgIcon({
  as: PlusRoundSvg,
  ariaLabel: 'plus round',
  category: 'status',
  displayName: 'PlusRound'
});
export default PlusRound;